import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom'
import { firestore } from '../../firebase';
import firebase from 'firebase';
import { FaEdit, FaTrashAlt } from 'react-icons/fa'

export default function ViewProduct() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [error, setError] = useState("");
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showResupply, setShowResupply] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [codigo, setCodigo] = useState("");
    const saveCodigo = useRef("");
    const [descripcion, setDescripcion] = useState("");
    const [cantActual, setCantActual] = useState(0);
    const [cantMin, setCantMin] = useState(0);
    const [categoria, setCategoria] = useState("");
    const [proveedorSelect, setProveedorSelect] = useState("");
    const [newProveedor, setNewProveedor] = useState("");
    const [divisa, setDivisa] = useState("CRC");
    const [precio, setPrecio] = useState(0);
    const [notas, setNotas] = useState("");
    const [reabastecimiento, setReabastecimiento] = useState(0);
    const [creatingResupply, setCreatingResupply] = useState(false);

    function getProduct() {
        setLoading(true);
        setError("");

        const productoQuery = firestore.collection('productos').doc(id)
        productoQuery.onSnapshot(querySnapshot => {
            if (!querySnapshot.exists) {
                setError("El producto no existe");
            } else {
                const data = querySnapshot.data();
                setCodigo(data.codigo);
                saveCodigo.current = data.codigo;
                setDescripcion(data.descripcion);
                setCantActual(data.cantidad.actual);
                setCantMin(data.cantidad.min);
                setCategoria(data.categoria);
                setProveedorSelect(data.proveedor);
                setDivisa(data.precio.divisa);
                setPrecio(data.precio.cantidad);
                setNotas(data.notas);
                setLoading(false);
            }
        })
    }

    function getProveedores() {
        setLoading(true);

        const proveedoresQuery = firestore.collection('proveedores').orderBy('nombre');
        proveedoresQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    nombre: data.nombre
                })
            })
            setProveedores(items);
            setLoading(false);
        })
    }

    async function handleSubmitEdit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!codigo || !descripcion || cantActual === '' || cantMin === '' ||
            !categoria || (!proveedorSelect && !newProveedor) || !divisa ||
            precio === '') {
                setError("Uno o más campos requeridos no llenados");
                setLoading(false);
                return null;
            }

        const editCodigo = codigo.trim();
        const editDescripcion = descripcion.trim();
        const editCantActual = cantActual;
        const editCantMin = cantMin;
        const editCategoria = categoria.trim();
        const editProveedor = proveedorSelect ? proveedorSelect.trim() : newProveedor.trim();
        const editDivisa = divisa.trim();
        const editPrecio = precio;
        const editNotas = notas.trim();

        setCodigo(editCodigo);
        setDescripcion(editDescripcion);
        setCategoria(editCategoria);
        setProveedorSelect(proveedorSelect.trim());
        setNewProveedor(newProveedor.trim());
        setDivisa(editDivisa);
        setNotas(editNotas);

        if (editCantActual < 0 || editCantMin < 0) {
            setError("Las cantidades no pueden ser menores a 0");
            setLoading(false);
            return null;
        }

        if (editPrecio < 0) {
            setError("El precio no puede ser menor a 0");
            setLoading(false);
            return null;
        }

        const duplicatesCodigo = await firestore
            .collection('productos')
            .where('codigo', '==', editCodigo)
            .get();

        if (editCodigo !== saveCodigo.current && !duplicatesCodigo.empty) {
            setError("El código del producto ya está en uso");
            setLoading(false);
            return null;
        }

        const newProduct = {
            codigo: editCodigo,
            descripcion: editDescripcion,
            proveedor: editProveedor,
            categoria: editCategoria,
            cantidad: {
                actual: parseInt(String(editCantActual)),
                min: parseInt(String(editCantMin))
            },
            precio: {
                divisa: editDivisa,
                cantidad: Number(editPrecio)
            },
            notas: editNotas,
            keywords: []
        }

        firestore.collection('productos').doc(id).update(newProduct)
        .then(() => {
            setShowEdit(true);
            setEditing(false);
            saveCodigo.current = editCodigo;
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleSubmitResupply(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (reabastecimiento === '') {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;        
        }

        if (reabastecimiento < 1) {
            setError("El reabastecimiento del producto debe ser de al menos 1");
            setLoading(false);
            return null;
        }

        const cantidadIncremento = reabastecimiento;
        const increment = firebase.firestore.FieldValue.increment(cantidadIncremento);
        const fechaReabastecimiento = new Date();

        const currentProductRef = firestore.collection('productos').doc(id);
        const newResupplyRef = firestore.collection('entradas').doc();

        firestore.runTransaction(async (t) => {
            const currentProduct = await t.get(currentProductRef);
            const cod = currentProduct.data().codigo;
            const desc = currentProduct.data().descripcion;

            await t.update(currentProductRef, {'cantidad.actual': increment});
            await t.set(newResupplyRef, {
                fecha: fechaReabastecimiento,
                cantidad: cantidadIncremento,
                producto: {
                    codigo: cod,
                    descripcion: desc,
                    id
                }
            })
        })
        .then(() => {
            setShowResupply(true);
            setCreatingResupply(false);
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);       
        })

    }

    function handleDelete(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        firestore.collection('productos').doc(id).delete()
        .then(() => {
            setShowDelete(false);
            setLoading(false);
            history.push("/products");
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setShowDelete(false);
            setLoading(false);
        })
    }

    useEffect(() => {
        getProduct();
        getProveedores();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Ver Producto</h2>
                <Modal show={showEdit} onHide={() => setShowEdit(false)}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se editó el producto correctamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowEdit(false)}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                    <Modal.Header>
                        <Modal.Title>Aviso</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Desea borrar el producto? Desaparecerá del sistema completamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleDelete}>
                            Aceptar
                        </Button>
                        <Button variant="secondary" onClick={() => setShowDelete(false)}>
                            Cancelar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showResupply} onHide={() => {setShowResupply(false); getProduct()}}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se reabasteció el producto correctamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => {setShowResupply(false); getProduct()}}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {creatingResupply ? 
                        <><h2 className="text-center mt-3 mb-4">Reabastecer</h2>
                        <Form onSubmit={handleSubmitResupply}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="entrada-cantidad">
                                    <Form.Label>Cantidad</Form.Label>
                                    <Form.Control 
                                    type="number"
                                    value={reabastecimiento}
                                    onChange={e => setReabastecimiento(e.target.value)}
                                    disabled={loading || editing || !creatingResupply}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || editing || !creatingResupply} type="submit">
                                        Confirmar
                                    </Button>
                                    <Button className='mx-1' disabled={loading || editing || !creatingResupply} variant="danger"
                                    onClick={() => {setCreatingResupply(false); getProduct();}}>
                                        Cancelar
                                    </Button>
                                </Col>
                            </Row>
                        </Form></>
                        :
                        <Form onSubmit={handleSubmitEdit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-codigo">
                                    <Form.Label>Código</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-description">
                                    <Form.Label>Nombre/Descripción</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={descripcion}
                                    onChange={e => setDescripcion(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="producto-cantidad-actual">
                                        <Form.Label>Cantidad Actual</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={cantActual}
                                        onChange={e => setCantActual(e.target.value)}
                                        disabled={loading || !editing}/>
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group className="mb-3" id="producto-cantidad-min">
                                        <Form.Label>Cantidad Mínima</Form.Label>
                                        <Form.Control 
                                        type="number" 
                                        value={cantMin}
                                        onChange={e => setCantMin(e.target.value)}
                                        disabled={loading || !editing}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12} sm={6}>
                                    <Form.Group className="mb-3" id="producto-select-categoria">
                                        <Form.Control
                                        as="select" custom
                                        value={categoria}
                                        onChange={e => setCategoria(e.target.value)}
                                        disabled={loading || !editing}
                                        >
                                            <option value="">Escoja una categoría</option>
                                            <option value="Equipo">Equipo</option>
                                            <option value="Consumible">Consumible</option>
                                            <option value="Repuesto">Repuesto</option>
                                            <option value="Otro">Otro</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Group className="mb-3" id="producto-select-proveedor">
                                    <Form.Control
                                        as="select" custom
                                        value={proveedorSelect}
                                        onChange={e => {
                                            setProveedorSelect(e.target.value);
                                            setNewProveedor("")
                                        }}
                                        disabled={loading || !editing}
                                        >
                                            <option value="">Escoja un proveedor</option>
                                            {proveedores 
                                            && proveedores.map(p => {
                                                return (
                                                    <option key={p.id} value={p.nombre}>{p.nombre}</option>
                                                )
                                            })}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Form.Group className="mb-3" id="producto-new-proveedor">
                                        <Form.Label>...o ingrese un nuevo proveedor</Form.Label>
                                        <Form.Control 
                                        type="text"
                                        value={newProveedor}
                                        onChange={e => {
                                            setNewProveedor(e.target.value);
                                            setProveedorSelect("");
                                        }}
                                        disabled={loading || !editing}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Col xs={12} sm={3}>
                                    <Form.Group className="mb-3" id="producto-select-divisa">
                                        <Form.Label>Divisa</Form.Label>{' '}
                                        <Form.Control
                                        as="select" custom
                                        value={divisa}
                                        onChange={e => setDivisa(e.target.value)}
                                        disabled={loading || !editing}
                                        >
                                            <option value="CRC">CRC</option>
                                            <option value="USD">USD</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={9}>
                                    <Form.Group className="mb-3" id="producto-precio">
                                        <Form.Label>Precio</Form.Label>
                                        <Form.Control 
                                        type="number"
                                        value={precio}
                                        onChange={e => setPrecio(e.target.value)}
                                        disabled={loading || !editing}/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="producto-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading || !editing}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || !editing} type="submit">
                                        Guardar
                                    </Button>
                                    <Button className='mx-1' disabled={loading || !editing} variant="danger"
                                    onClick={() => {setEditing(false); getProduct();}}>
                                        Cancelar
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setEditing(true)}>
                                        <span><FaEdit/></span>
                                    </Button>
                                    <Button className='m-1 py-0 px-1' disabled={loading} variant="link" style={{fontSize: "1.65rem"}}
                                    onClick={() => setShowDelete(true)}>
                                        <span><FaTrashAlt/></span>
                                    </Button>
                                </Col>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={12}>
                                    <Button className='mx-1' disabled={loading || editing} variant="success"
                                    onClick={() => setCreatingResupply(true)}>
                                        Reabastecer Producto
                                    </Button>
                                    <Button className='mx-1' disabled={loading || editing} variant="success"
                                    onClick={() => history.push(`/products/add-to-sale_${id}`)}>
                                        Agregar a Venta
                                    </Button>
                                </Col>                           
                            </Row>
                        </Form>}
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}